<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper" v-if="form.id">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <Form @submit="updateCase">
            <div class="contact-head">
              <div class="row align-items-center">
                <div class="col-sm-6">
                  <ul class="contact-breadcrumb">
                    <li>
                      <button type="submit" class="custom-header-button">
                        <i class="ti ti-check"></i> Save
                      </button>
                    </li>
                    <li>
                      <router-link
                        :to="{
                          path: '/crm/organisation-details',
                          query: { ter_Id: terId, org_Id: orgId, caseId: form.id, for: 'support-cases' },
                        }"
                      >
                        <i class="ti ti-arrow-narrow-left"></i>
                        Organisation
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="card mb-3">
              <div class="card-body">
                <h4
                  class="d-flex align-items-center my-2"
                  :class="{ 'text-danger': openComplaint }"
                >
                  {{ organizationName }}
                  <span v-if="openComplaint" class="badge bg-danger ms-2">Open complaint</span>
                </h4>
                <p class="mb-0 text-muted">Case #{{ form.ticket_number || '—' }}</p>
              </div>
            </div>

            <div class="card">
              <div class="card-body settings-form">
                <h4 class="mb-3">Support Case details</h4>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-wrap">
                      <label class="col-form-label">Type</label>
                      <Field as="select" name="ticket_type" class="form-select" v-model="form.ticket_type">
                        <option value="">-----Select-----</option>
                        <option v-for="opt in typeOptions" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
                      </Field>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-wrap">
                      <label class="col-form-label">Status</label>
                      <Field as="select" name="status" class="form-select" v-model="form.status">
                        <option value="">-----Select-----</option>
                        <option v-for="opt in statusOptions" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
                      </Field>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-wrap">
                      <label class="col-form-label">Source</label>
                      <Field as="select" name="source" class="form-select" v-model="form.source">
                        <option value="">-----Select-----</option>
                        <option v-for="opt in sourceOptions" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
                      </Field>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-wrap">
                      <label class="col-form-label">Action</label>
                      <Field as="select" name="action" class="form-select" v-model="form.action">
                        <option value="">-----Select-----</option>
                        <option v-for="opt in actionOptions" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
                      </Field>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-wrap">
                      <label class="col-form-label">Deadline</label>
                      <Field name="deadline" type="datetime-local" class="form-control" v-model="form.deadline" />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-wrap">
                      <label class="col-form-label">Responsible</label>
                      <Field as="select" name="responsible" class="form-select" v-model="form.responsible">
                        <option value="">-----Select-----</option>
                        <option v-for="res in responsibleOptions" :key="res.id" :value="res.id">{{ res.name }}</option>
                      </Field>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-wrap">
                      <label class="col-form-label">Contact person</label>
                      <Field as="select" name="contact_person" class="form-select" v-model="form.contact_person">
                        <option value="">-----Select-----</option>
                        <option v-for="p in orgPersons" :key="p.id" :value="p.id">{{ p.name }}</option>
                      </Field>
                    </div>
                  </div>
                  <div class="col-md-8">
                    <div class="form-wrap">
                      <label class="col-form-label">Subject</label>
                      <Field name="subject" type="text" class="form-control" v-model="form.subject" />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-wrap">
                      <label class="col-form-label">Description</label>
                      <Field as="textarea" name="description" class="form-control" rows="3" v-model="form.description" />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-wrap">
                      <label class="col-form-label">Email CC</label>
                      <Field name="email_cc" type="text" class="form-control" v-model="form.email_cc" />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-wrap mb-0" style="border: 1px solid #e1e1e1;">
                      <h4 class="p-2 mb-0">Logs</h4>
                      <p class="col-form-label p-2 mb-0" style="background-color: #eff1f0;">Add log entry</p>
                      <Field as="textarea" name="content" class="form-control" rows="3" v-model="form.content" />
                    </div>
                    <div class="row my-3">
                      <div class="col-md-12">
                        <div class="form-wrap mb-0 shadow resizable" style="border: 1px solid #e1e1e1;">
                          <p class="col-form-label p-2 log-head mb-0">Case log</p>
                          <div class="row" v-for="log in logs" :key="log.id">
                            <div class="col-12">
                              <p class="p-2 mb-0" style="border-bottom: 1px solid #e1e1e1; white-space: pre-wrap;">
                                {{ log.content }}
                              </p>
                            </div>
                          </div>
                          <p v-if="!logs.length" class="p-2 mb-0 text-muted">No log entries yet.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { Form, Field } from 'vee-validate';
import moment from 'moment';

function toDatetimeLocal(value) {
  if (!value) return '';
  const m = moment(value);
  if (!m.isValid()) return '';
  return m.format('YYYY-MM-DDTHH:mm');
}

export default {
  components: { Form, Field },
  setup() {
    const store = useStore();
    const route = useRoute();
    const caseId = ref(route.query.caseId || null);
    const orgId = ref(route.query.org_Id || null);
    const terId = ref(route.query.ter_Id || null);
    const form = ref({});
    const logs = ref([]);
    const orgPersons = ref([]);
    const organizationName = ref('');
    const openComplaint = ref(false);

    const dropdowns = computed(() => store.getters['orgSupportCases/getOrgSupportCaseDropdowns'] || {});
    const typeOptions = computed(() => dropdowns.value.support_type || []);
    const statusOptions = computed(() => dropdowns.value.support_status || []);
    const actionOptions = computed(() => dropdowns.value.support_action || []);
    const sourceOptions = computed(() => dropdowns.value.support_source || []);
    const responsibleOptions = computed(() => store.getters['organisation/getresUsersOptions'] || []);

    const loadCase = async () => {
      if (!caseId.value) return;
      const data = await store.dispatch('orgSupportCases/fetchOrgSupportCase', caseId.value);
      if (!data) return;
      form.value = {
        id: data.id,
        ticket_number: data.ticket_number,
        ticket_type: data.ticket_type || '',
        status: data.status || '',
        source: data.source || '',
        action: data.action || '',
        deadline: toDatetimeLocal(data.deadline),
        responsible: data.responsible || '',
        contact_person: data.contact_person || '',
        subject: data.subject || '',
        description: data.description || '',
        email_cc: data.email_cc || '',
        content: '',
      };
      logs.value = data.logs || [];
      organizationName.value = data.organization_name || '';
      openComplaint.value = String(data.open_complaint || '').toLowerCase() === 'yes';
      if (data.organization_id) orgId.value = data.organization_id;
      if (data.territory_id) terId.value = data.territory_id;
    };

    const updateCase = async () => {
      const res = await store.dispatch('orgSupportCases/updateOrgSupportCase', { ...form.value });
      if (res?.status) {
        form.value.content = '';
        await loadCase();
      }
    };

    onMounted(async () => {
      await store.dispatch('orgSupportCases/fetchOrgSupportCaseOptions');
      await loadCase();
      if (terId.value) {
        await store.dispatch('organisation/fetchTerritoryCompanyUsers', terId.value);
      }
      if (orgId.value) {
        orgPersons.value = (await store.dispatch('opportunity/fetchPersons', orgId.value)) || [];
      }
    });

    return {
      form,
      logs,
      orgId,
      terId,
      organizationName,
      openComplaint,
      typeOptions,
      statusOptions,
      actionOptions,
      sourceOptions,
      responsibleOptions,
      orgPersons,
      updateCase,
    };
  },
};
</script>
